import "./EquityOrderDisplayComponent.scss";
import template from "./EquityOrderDisplayComponent.html";
import {IComponentOptions} from "angular";
import {EquityWizardData} from "../../../place-equity-order-wizard/models/EquityWizardData";

export const EquityOrderDisplay = "tfEquityOrderDisplay";

export function equityOrderDisplay(): IComponentOptions {
    return {
        template,
        bindings: {
            order: "<"
        },
        controllerAs: "ctrl",
        controller: EquityOrderDisplayComponentController
    };
}

export class EquityOrderDisplayComponentController {
    /** @input */
    public readonly order: EquityWizardData;
}
